export default {
  //
  x_status: {
    active: 'Cursando',
    exam: 'Examen',
    draft: 'Borrador',
    canceled: 'Cancelado'
  }
}
